module.exports = __webpack_public_path__ + "r-v3/img/more_gray.ba415c31.svg";